import $ from "jquery";
import Util from "./../util";
import Tab from "./../tab";
import Modal from "./../modal";
import Variables from "./../variables";
import Mapbox from "./../mapbox";
import listTemplate from "./templates/list.html";
import propListTemplate from "./templates/prop-list.html";
import listWidgetInfoWindow from "./templates/list-widget-info-window.html";
import viewTemplate from "./templates/view.html";
import viewLeadErrorsTemplate from "./templates/view-lead-errors.html";
import viewLeadSuccessTemplate from "./templates/view-lead-success.html";
import liquidjs from "./../liquidjs";
import queryString from "query-string";
import { default as dateParse } from "date-fns/parse";
import { default as dateFormat } from "date-fns/format";

const PropertyListWidget = (($) => {
  const Liquid = new liquidjs.Liquid();

  const qs = queryString.parse(location.search);

  Liquid.registerFilter(
    "currency",
    function (val, country = "en-US", currency = "USD") {
      return new Intl.NumberFormat(country, {
        style: "currency",
        currency: currency,
      }).format(val);
    }
  );

  Liquid.registerFilter(
    "boolean",
    function (val, trueVal = "Yes", falseVal = "No", nullVal = "") {
      if (val == 1 || val == "true" || val == true) {
        return trueVal;
      } else if (val == 0 || val == "false" || val == false) {
        return falseVal;
      }

      return nullVal;
    }
  );

  Liquid.registerFilter("addressInline", function (obj) {
    const parts = [];

    parts.push(obj.address);

    if (obj.address2 && obj.address2.length > 0) {
      parts.push(obj.address2);
    }

    parts.push(obj.city + ", ");
    parts.push(obj.stateID);
    parts.push(obj.postalCode);

    return parts.join(" ");
  });

  Liquid.registerFilter(
    "availabilityDate",
    (dateStr, beforeStr = "Immediately", label = "Available: ") => {
      if (!dateStr) {
        return beforeStr;
      }
      const dateAvailable = dateParse(dateStr, "yyyy-MM-dd", new Date());
      if (beforeStr == "date") {
        if (dateStr) {
          return (label ? label : "") + dateFormat(dateAvailable, "MM/dd/yyyy");
        } else {
          return "";
        }
      }

      const today = new Date();
      if (dateAvailable <= today) {
        return (label ? label : "") + beforeStr;
      }
      return (label ? label : "") + dateFormat(dateAvailable, "MM/dd/yyyy");
    }
  );

  Liquid.registerFilter("formatDate", function (val, format = "MM/dd/yyyy") {
    if (!val) {
      return "";
    }
    const theDate = dateParse(val, "yyyy-MM-dd", new Date());

    return dateFormat(dateAvailable, format);
  });

  Liquid.registerFilter("phone", function (val) {
    if (!val) {
      return "";
    }

    if (/\D/.test(val)) {
      return val;
    }

    if (val.length == 10) {
      return val.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
    } else if (val.length == 11) {
      return val.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, "+$1 ($2) $3-$4");
    }

    return val;
  });

  const NAME = "PropertyListWidget";
  const VERSION = "4.1.1";
  const DATA_KEY = "nh.propertyListWidget";
  const EVENT_KEY = `.${DATA_KEY}`;
  const DATA_API_KEY = ".data-api";
  const JQUERY_NO_CONFLICT = $.fn[NAME];

  const Selector = {
    ROOT: "#nhjw-property-list-view",
    MODULE_INFO: "#nhjw-listing-page",
    SEARCH_FORM: "#nhjw-prop-list-search-form",
    PROP_LIST_CONTAINER: "#nhjw-prop-list-view-prop-list",
    NAVIGATION: "#nhjw-property-list-tab-list",
    NAVIGATION_TABS: "li > ." + Variables.prefix + "-nav-link",
    PAGINATION_LINK: ".nhjw-pagination .nhw-page-link",
    MAP: "#nhjw-property-map-panel",
    PLUGIN_INFO: "#nesthub-plugin",
    FORM_KEYWORD: "#nhjw-prop-search-keyword-input",
    FORM_MIN_RENT: "#nhjw-prop-search-min-rent-input",
    FORM_MAX_RENT: "#nhjw-prop-search-max-rent-input",
    FORM_BEDS: "#nhjw-prop-search-beds-input",
    FORM_BATHS: "#nhjw-prop-search-baths-input",
    FORM_PROPERTY_TYPE: "#nesthub-listing-prop-search-property-type",
    FORM_PETS: "#nesthub-listing-prop-search-pets",
    FORM_SORT: "#nesthub-listing-prop-search-sort",
    INFO_WINDOW_LINK: ".nhw-map-property-info-window",
    PROP_LINK: ".nhjw-prop-link",
    MODAL_CONTAINER: "#nhjw-prop-list-view-modal",
    VIEW_CONTAINER: "#nhjw-prop-view-modal-content",
    VIEW_NAVIGATION: "#nhjw-property-detail-tab-list",
    VIEW_NAVIGATION_TABS: "li > ." + Variables.prefix + "-nav-link",
    VIEW_MAP: "#nhjw-property-view-map-panel",
    VIEW_IMAGE_BTN: "#nhjw-property-view-gallery-btn",
    VIEW_MAIN_IMAGE: "#nhjw-property-view-main-image",
    VIEW_FORM: "#nhjw-property-lead-form",
    VIEW_FORM_ERRORS: "#nhjw-property-lead-form-errors",
  };

  const ViewLoadingHtml =
    '<div class="nhw-modal-body"><div style="text-align:center;">Loading Listing...</div></div>';

  const Api = {
    ENDPOINT: "/_system/api/listings",
  };

  const Modes = {
    List: 1,
    View: 2,
  };

  const Constants = {
    PropertyTypes: [
      { label: "Single Family Home", id: 1 },
      { label: "Apartment", id: 2 },
      { label: "Condo", id: 3 },
      { label: "Townhouse", id: 4 },
      { label: "Duplex", id: 5 },
      { label: "Multiplex", id: 6 },
      { label: "Loft", id: 7 },
      { label: "Mobile Home", id: 8 },
      { label: "Commercial", id: 9 },
      { label: "Garage", id: 10 },
      { label: "Other", id: 11 },
    ],
    PetFilterOptions: [
      { label: "Dogs Allowed", id: 1 },
      { label: "Cats Allowed", id: 2 },
      { label: "Dogs and Cats Allowed", id: 3 },
      { label: "No Pets Allowed", id: 4 },
    ],
  };

  const TemplateTypes = {
    list: {
      name: "list",
      default: listTemplate,
      dataTag: "list",
    },
    propList: {
      name: "propList",
      default: propListTemplate,
      dataTag: "propList",
    },
    infoWindow: {
      name: "infoWindow",
      default: listWidgetInfoWindow,
      dataTag: "infoWindow",
    },
    view: {
      name: "view",
      default: viewTemplate,
      dataTag: "view",
    },
    viewLeadError: {
      name: "viewLeadError",
      default: viewLeadErrorsTemplate,
      dataTag: "viewLeadError",
    },
    viewLeadSuccess: {
      name: "viewLeadSuccess",
      default: viewLeadSuccessTemplate,
      dataTag: "viewLeadSuccess",
    },
  };

  class PropertyListWidget {
    constructor(element) {
      this._element = element;
      this._mode = Modes.List;
      this._routes = [
        { pattern: "^#\\?[.]*$", mode: Modes.List },
        { pattern: "^#properties($|\\?[.]*)", mode: Modes.List },
        { pattern: "^#properties/[0-9]+($|\\?[.]*)", mode: Modes.View },
      ];
      this._cache = {
        templates: {},
      };

      this._settings = {
        listMapZoom: 8,
        viewMapZoom: 8,
        pageSize: 24,
        defaultFilters: {},
        hardFilters: {},
        ...$(this._element).data(),
      };

      this._filters = {};

      this._initialized = false;

      this._propListContainer = null;
      this._modalContainer = null;
      this._viewContainer = null;
      this._viewMap = null;
      this._viewFormSubmitting = false;

      this._modal = null;

      this._init();

      this._render();
    }

    static get VERSION() {
      return VERSION;
    }

    _init() {
      const self = this;

      if (this._settings.defaultFilters) {
        try {
          this._settings.defaultFilters = JSON.parse(
            this._settings.defaultFilters
          );
        } catch (e) {
          try {
            this._settings.defaultFilters = queryString.parse(
              this._settings.defaultFilters
            );
          } catch (e) {
            this._settings.defaultFilters = {};
          }
        }
      }

      if (this._settings.hardFilters) {
        try {
          this._settings.hardFilters = JSON.parse(this._settings.hardFilters);
        } catch (e) {
          try {
            this._settings.hardFilters = queryString.parse(
              this._settings.hardFilters
            );
          } catch (e) {
            this._settings.hardFilters = {};
          }
        }
      }

      $(this._element).on("click", Selector.INFO_WINDOW_LINK, (event) => {
        const id = $(event.target).closest(".nhjw-prop-link").data("id");
        if (id) {
          this._showListing(id);
        }
      });
    }

    _getTemplate(type) {
      if (!this._cache.templates[type.name]) {
        this._cache.templates[type.name] = Liquid.parse(type.default);
      }
      return this._cache.templates[type.name];
    }

    _findRoute() {
      let routeFound = false;
      i = 0;

      if (this.routes) {
        while (!routeFound && i < this.routes.length) {
          route = this.routes[i];
          if (this._checkRoute(route.pattern)) {
            routeFound = true;
          }
        }
      }
    }

    _checkRoute(pattern, options) {
      let routePath = window.location.hash;
      if (pattern.substring(0, 3) === "^\\?") {
        routePath = window.location.search;
      }

      return this._checkPattern(routePath, pattern, options);
    }

    _checkPattern(route, pattern, options) {
      let regex = pattern;

      if (typeof pattern === "string") {
        regex = new RegExp(pattern, options);
      }

      return regex.test(route);
    }

    _render() {
      const template = this._getTemplate(TemplateTypes.list);
      const params = {
        constants: Constants,
      };

      Liquid.render(template, params).then((html) => {
        $(this._element).html(html);

        this._propListContainer = $(
          Selector.PROP_LIST_CONTAINER,
          this._element
        ).first();

        if (!this._modalContainer) {
          this._modalContainer = document.createElement("div");
          this._modalContainer.id = "nhjw-prop-list-view-modal";
          this._modalContainer.classList.add("nhw-modal");
          this._modalContainer.tabIndex = -1;
          this._modalContainer.role = "dialog";

          this._modalContainer.innerHTML =
            '<div class="nhw-modal-dialog nhw-modal-lg" role="document"><div id="nhjw-prop-view-modal-content" class="nhw-modal-content"></div></div>';
          document.body.appendChild(this._modalContainer);
        }

        this._viewContainer = $(
          Selector.VIEW_CONTAINER,
          this._modalContainer
        ).first();

        this._modal = new Modal(this._modalContainer, {
          backdrop: "static",
          keyboard: false,
        });

        this._viewContainer.html(ViewLoadingHtml);

        $(Selector.SEARCH_FORM, this._element).on("submit", (event) => {
          const form = event.target;
          event.preventDefault();

          const filters = {};
          $(":input", form).each(function (__, element) {
            const value = $(element).val();
            const name = $(element).attr("name");
            if (value && value.length > 0) {
              filters[name] = value;
            }
          });

          this._searchListings(filters);
        });

        this._searchListings(
          this._settings.defaultFilters ? this._settings.defaultFilters : {}
        );
      });
    }

    _searchListings(filters) {
      const self = this;
      this._filters = filters;

      $(this._propListContainer)
        .empty()
        .html('<div style="text-align:center">Loading Listings...</div>');

      let endpoint = Api.ENDPOINT;
      let data = $.extend(filters, {
        pageSize: this._settings.pageSize,
        ...this._settings.hardFilters,
      });

      $.ajax(endpoint, {
        method: "GET",
        data: data,
      }).done((responseData) => {
        this._filters = filters;

        // if (history && history.pushState && this._initialized) {
        //   var newurl =
        //     window.location.protocol +
        //     "//" +
        //     window.location.host +
        //     window.location.pathname +
        //     (this._filters && Object.keys(this._filters).length > 0)
        //       ? "?" + queryString.stringify(this._filters)
        //       : "";
        //   window.history.pushState({ path: newurl }, "", newurl);
        // }
        const view = {};

        view.settings = this._settings;
        view.listings = responseData.listings;
        view.pagination = responseData.pagination;
        view.constants = Constants;
        view.pagination.pages = [];
        const currentPage = parseInt(view.pagination.current);
        if (view.pagination.last > 1) {
          for (var i = currentPage - 3; i < currentPage; i++) {
            if (i > 0) {
              view.pagination.pages.push(i);
            }
          }

          view.pagination.pages.push(currentPage);

          for (var i = currentPage + 1; i < currentPage + 5; i++) {
            if (i > view.pagination.last) {
              break;
            }
            view.pagination.pages.push(i);
          }
        }

        view.pagination.firstItem =
          (view.pagination.current - 1) * view.pagination.limit + 1;
        view.pagination.lastItem =
          view.pagination.current * view.pagination.limit;

        if (view.listings.length > 0) {
          view.showList = true;
          view.map = {
            latitude: view.listings[0].latitude,
            longitude: view.listings[0].longitude,
          };
        } else {
          view.showList = false;
        }

        const template = this._getTemplate(TemplateTypes.propList);

        if (template) {
          Liquid.render(template, view).then((html) => {
            window.scrollTo(0, 0);
            $(this._propListContainer).html(html);

            const listNavigation = $(Selector.NAVIGATION, this._element)[0];

            $(Selector.PROP_LINK, this._element).on("click", (event) => {
              const id = $(event.target).closest(".nhjw-prop-link").data("id");
              if (id) {
                this._showListing(id);
              }
            });

            $(Selector.PAGINATION_LINK, this._element).on("click", (event) => {
              event.preventDefault();

              const newPage = $(event.target).data("page");

              this._searchListings($.extend(this._filters, { pg: newPage }));
            });

            // Bind handlers.
            $(Selector.NAVIGATION_TABS, listNavigation).on(
              "click",
              function (event) {
                event.preventDefault();

                const $this = $(this);
                let data = $this.data(DATA_KEY);

                if (!data) {
                  data = new Tab(this);
                  $this.data(DATA_KEY, data);
                }

                if (this.id == "nhjw-property-map-tab") {
                  self._showMap();
                  self._mode = Modes.MAP;
                } else {
                  self._mode = Modes.LIST;
                }

                data.show();
              }
            );

            if (!this._initialized) {
              this._initialized = true;
              if (qs.listingID) {
                this._showListing(qs.listingID);
              }
            }
          });
        }
      });
    }

    _showListing(id) {
      let endpoint = Api.ENDPOINT;

      const self = this;

      if (!id) {
        return;
      }

      this._viewContainer.html(ViewLoadingHtml);

      this._modal.show();

      $.ajax(`${endpoint}/${id}`, {
        method: "GET",
      })
        .done((responseData) => {
          //   if (history && history.pushState) {
          //     var newurl =
          //       window.location.protocol +
          //       "//" +
          //       window.location.host +
          //       window.location.pathname +
          //       id
          //         ? "?" + queryString.stringify({ listingID: id })
          //         : "";
          //     window.history.pushState({ path: newurl }, "", newurl);
          //   }
          const template = this._getTemplate(TemplateTypes.view);

          const view = { ...responseData };
          if (this._settings.defaultApplicationUrl) {
            view.listing.applicationUrl = this._settings.defaultApplicationUrl;
          }

          if (template) {
            Liquid.render(template, view).then((html) => {
              this._viewContainer.html(html);

              this._viewMap = null;

              const viewNavigation = $(
                Selector.VIEW_NAVIGATION,
                this._viewContainer
              )[0];

              $(".nhjw-prop-close", this._modalContainer).on(
                "click",
                (event) => {
                  self._modal.hide();
                }
              );

              $(Selector.VIEW_NAVIGATION_TABS, viewNavigation).on(
                "click",
                function (event) {
                  event.preventDefault();

                  const $this = $(this);
                  let data = $this.data(DATA_KEY);

                  if (!data) {
                    data = new Tab(this);
                    $this.data(DATA_KEY, data);
                  }

                  if (this.id == "nhjw-property-view-map-tab") {
                    self._showListingMap();
                  }

                  data.show();
                }
              );

              $(Selector.VIEW_IMAGE_BTN, this._viewContainer).on(
                "click",
                function (event) {
                  $(Selector.VIEW_MAIN_IMAGE, this._viewContainer).click();
                }
              );

              $(Selector.VIEW_FORM, this._viewContainer).on(
                "submit",
                (event) => {
                  event.preventDefault();
                  if (this._viewFormSubmitting) {
                    return;
                  }

                  this._viewFormSubmitting = true;

                  const form = event.target;

                  const data = {};
                  $(":input", form).each(function (__, element) {
                    const value = $(element).val();
                    const name = $(element).attr("name");
                    if (value && value.length > 0) {
                      data[name] = value;
                    }
                  });

                  data.listingID = id;

                  $.ajax(`${endpoint}/lead`, {
                    method: "POST",
                    data: JSON.stringify(data),
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                  })

                    .done((responseData) => {
                      const successTemplate = this._getTemplate(
                        TemplateTypes.viewLeadSuccess
                      );

                      if (successTemplate) {
                        Liquid.render(successTemplate, {}).then((html) => {
                          $(Selector.VIEW_FORM, this._viewContainer).html(html);
                        });
                      }
                    })
                    .fail((response) => {
                      this._viewFormSubmitting = false;

                      const errors = [];
                      Object.keys(response.responseJSON).forEach((key) => {
                        if (Array.isArray(response.responseJSON[key])) {
                          response.responseJSON[key].forEach((message) => {
                            errors.push(message);
                          });
                        } else {
                          errors.push(response.responseJSON[key]);
                        }
                      });
                      const errorTemplate = this._getTemplate(
                        TemplateTypes.viewLeadError
                      );

                      if (errorTemplate) {
                        Liquid.render(errorTemplate, { errors }).then(
                          (html) => {
                            $(
                              Selector.VIEW_FORM_ERRORS,
                              this._viewContainer
                            ).html(html);
                          }
                        );
                      }
                    });
                }
              );
            });
          }
        })
        .error((response) => {
          this._modal.hide();
        });
    }

    _showMap() {
      const self = this;

      if (!this._map) {
        this._map = new Mapbox($(Selector.MAP, this._element)[0]);
        this._map.show(function (map) {
          self._map.onBoundsChange((event) => {
            self._handleMapBoundsChange(event);
          });
        });
      }
    }

    _handleMapBoundsChange() {
      const self = this;

      if (!this._map) {
        return;
      }

      let mapInfo = this._map.getMapInfo();
      let formData = this._filters;

      let data = $.extend(
        {
          latitudeMin: mapInfo.minLat,
          latitudeMax: mapInfo.maxLat,
          longitudeMin: mapInfo.minLon,
          longitudeMax: mapInfo.maxLon,
        },
        formData,
        {
          pageSize: 500,
          pg: 1,
        }
      );

      let endpoint = Api.ENDPOINT;

      $.ajax(endpoint, {
        method: "GET",
        data: data,
      })
        .done(function (data, textStatus, jqXHR) {
          self._map.clearMarkers();

          data.listings.forEach(function (listing) {
            let marker = self._map.addMarker(
              parseFloat(listing.latitude),
              parseFloat(listing.longitude)
            );
            marker.getElement().addEventListener("click", () => {
              self._handleMarkerClick(marker, listing);
            });
          });
        })
        .fail(function (jqXHR, textStatus, errorThrown) {});
    }

    _handleMarkerClick(marker, listing) {
      if (!this._map) {
        return;
      }

      const data = {};

      const container = document.createElement("div");

      data.beds =
        listing.beds > 0
          ? listing.beds > 1
            ? listing.beds + " beds"
            : "1 bed"
          : "Studio";
      data.id = listing.listingID;
      data.baths = listing.baths != 1 ? listing.baths + " baths" : "1 bath";
      data.area = listing.area > 0 ? formatArea(listing.area) : "";
      data.url = listing.systemUrl;
      data.imgUrl = `${listing.imageUrl}?size=small`;
      data.imgAlt = listing.url;
      data.amount = listing.rent;

      const template = this._getTemplate(TemplateTypes.infoWindow);
      if (template) {
        Liquid.render(template, data).then((html) => {
          container.innerHTML = html;
          this._map.openInfoWindowOnMarker(container, marker);
        });
      }

      //const content = Mustache.render(Templates.INFO_WINDOW, data);
      //container.innerHTML = content;
    }

    _showListingMap() {
      if (!this._viewMap) {
        let $map = $(Selector.VIEW_MAP, this._viewContainer);
        if ($map.length > 0) {
          let lat = parseFloat($map.data("lat"));
          let lng = parseFloat($map.data("lng"));
          let title = $map.data("title");

          this._viewMap = new Mapbox($map[0]);
          this._viewMap.show(() => {
            this._viewMap.addMarker(lat, lng, title);
          });
        }
      } else {
        setTimeout(() => {
          this._viewMap.resize();
        }, 500);
      }
    }

    _renderList() {
      $(this._propListContainer).empty();

      let endpoint = Api.ENDPOINT;
      let data = {
        pageSize: 10,
      };
    }
  }

  $("[data-ion='listing-widget']").each(function (index, element) {
    const $element = $(element);
    let data = $element.data("ion.listingWidget");

    if (!data) {
      data = new PropertyListWidget(element);
      $element.data("ion.listingWidget", data);
    }

    if (typeof config === "string") {
      if (typeof data[config] === "undefined") {
        throw new TypeError(`No method named "${config}"`);
      }
      data[config]();
    }
  });
})($);

export default PropertyListWidget;
